export default __webpack_public_path__ + "static/media/book_image4.55fb8590.jfif";